import React from "react";
function Module () {
    return (

        <h2>Module</h2>
    )
    
}
export default Module;